var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('page-section',[_c('div',{staticClass:"space-y-4 sm:grid sm:gap-4 sm:grid-cols-3 sm:space-y-0 md:gap-8 lg:gap-32"},[_c('invoice-duplicate-action'),_c('facilitation-payment-action'),_c('extend-term-of-payment-action')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }